import { RpcError } from "grpc-web";
import { GetUserResponse } from "./../proto/api_pb.d";
import { useCallback, useEffect, useState } from "react";
import { OmmuseClient } from "../proto/api_grpc_web_pb";
import { GetUserRequest, User } from "../proto/api_pb";
import { backOff } from "exponential-backoff";
import { useAuth0 } from "@auth0/auth0-react";
import useGetValidAccessToken from "./useGetValidAccessToken";

type ReturnType = {
  user: User | undefined;
  isUserLoading: boolean;
  getUserResponse: GetUserResponse | undefined;
  getUserError: RpcError | undefined;
  emailVerified: boolean | undefined;
};

export const useGetUser = (userId?: string): ReturnType => {
  const [ommuseUser, setUser] = useState<User>();
  const [getUserResponse, setGetUserResponse] = useState<GetUserResponse>();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<RpcError>();
  const { user } = useAuth0();
  const { getValidAccessToken } = useGetValidAccessToken();

  const getCurrentUser = useCallback(async () => {
    try {
      if (userId && userId !== "") {
        setIsLoading(true);
        const accessToken = await getValidAccessToken();
        const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
        const request = new GetUserRequest();
        request.setUserId(userId);
        const metadata = {
          Authorization: `${accessToken}`,
          "Access-Control-Allow-Origin": "*",
        };
        await backOff(
          () =>
            new Promise((resolve, reject) => {
              ommuseClient.getUser(request, metadata, function (err, response) {
                if (err) {
                  console.log(err.code);
                  console.log(err.message);
                  setIsLoading(false);
                  reject(err);
                } else {
                  setUser(response);
                  setGetUserResponse(response);
                  setIsLoading(false);
                  resolve(response);
                }
              });
            }),
          {
            numOfAttempts: 2,
            jitter: "full",
            timeMultiple: 5,
          }
        );
      }
    } catch (error) {
      setError(error as RpcError);
    }
  }, [userId, getValidAccessToken]);

  useEffect(() => {
    getCurrentUser();
  }, [getCurrentUser]);

  return {
    user: ommuseUser,
    isUserLoading: isLoading,
    getUserResponse,
    getUserError: error,
    emailVerified: user ? user.email_verified : undefined,
  };
};
